module.exports = __webpack_public_path__ + "static/media/home.6c47c90d.svg";